import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { Router, RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { AppState } from 'src/app/ngrx/states'
import { verification } from 'src/app/ngrx/store/actions'
import { getEmail } from 'src/app/ngrx/store/selectors'
import { AuthUserService } from 'src/app/service/auth/auth-user.service'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { DdcButtonROneComponent } from 'src/app/shared/ddc/ddc-button-r-one/ddc-button-r-one.component'
import { DdcButtonSOneComponent } from 'src/app/shared/ddc/ddc-button-s-one/ddc-button-s-one.component'
import { DdcTextGradientComponent } from 'src/app/shared/ddc/ddc-text-gradient/ddc-text-gradient.component'
import { MyErrorStateMatcher } from 'src/app/shared/models/matcher'
@Component({
  selector: 'ddc-verification',
  templateUrl: './ddc-verification.component.html',
  styleUrls: ['./ddc-verification.component.scss'],
  imports: [
    AngularMaterialsModules,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    DdcTextGradientComponent,
    DdcButtonSOneComponent,
    DdcButtonROneComponent,
  ],
})
export class DdcVerificationComponent implements OnInit {
  _aCode: string
  _email: string
  _isVerBtnLoading = false
  _submitBtnText = 'Verify'
  _hide = true
  _VerError: string = ''
  _codeLength = 6
  _verificationCodePattern = '^\\d{6}$'

  _form = new FormGroup({
    _code: new FormControl('', [
      Validators.required,
      Validators.pattern(this._verificationCodePattern),
      Validators.minLength(this._codeLength),
      Validators.maxLength(this._codeLength),
    ]),
  })

  // emailFormControl = new FormControl('', [Validators.required, Validators.email])
  _matcher = new MyErrorStateMatcher()

  constructor(
    private logger: DdcLoggerService,
    private store: Store<AppState>,
    private authService: AuthUserService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(verification())

    this.store.select(getEmail).subscribe(email => {
      this._email = email
    })
  }

  verify(): void {
    this.logger.info('DdcVerificationComponent: verify()')
    if (!this._form.valid) return

    if (this._email === null || this._email.length === 0) {
      this._form.setErrors({
        invalid_OTP_Code: true,
      })
      this._VerError = 'No registered email found. Please signup first.'
      this._isVerBtnLoading = false
      this._submitBtnText = 'Verify'
      return
    }

    this._isVerBtnLoading = true
    this._submitBtnText = 'Verifying ...'

    this.authService.verify(this._form.value, this._email).subscribe((res: any) => {
      if (!res.success) {
        this.logger.error('DdcVerificationComponent | verify | res:', res)
        this._isVerBtnLoading = true
        this._submitBtnText = 'Verifying ...'

        setTimeout(() => {
          this._VerError = res.message
          this._form.setErrors({
            invalid_OTP_Code: true,
          })
          // this.store.dispatch(home())
          this.router.navigate(['/verification'])
          this._isVerBtnLoading = false
          this._submitBtnText = 'Verify'
        }, 2000) // two seconds
      } else {
        this._submitBtnText = 'Verified ! forwarding ...'

        setTimeout(() => {
          // this.store.dispatch(home())
          this.router.navigate(['/login'])
          this._isVerBtnLoading = false
          this._submitBtnText = 'Verify'
        }, 2000) // two seconds
      }
    })
  }

  get code(): any {
    return this._form.get('_code')
  }
}
